import WarehouseList from '@/pages/Warehouse/WarehouseList';
import WarehouseCard from '@/pages/Warehouse/WarehouseCard';
import AddWarehouse from '@/pages/Warehouse/AddWarehouse';

export default [
    {
        path: '/magazyny',
        component: WarehouseList,
        meta: { requiresAuth: true },
        name: 'warehouse-list'
    },
    {
        path: '/magazyn/:id',
        component: WarehouseCard,
        name: 'warehouse-card',
        meta: { requiresAuth: true }
    },
    {
        path: '/dodaj-magazyn-rejonowy',
        component: AddWarehouse,
        meta: { requiresAuth: true },
        name: 'warehouse-data',
        props: true
    },
    {
        path: '/dodaj-magazyn-wspierajacy',
        component: AddWarehouse,
        meta: { requiresAuth: true },
        name: 'supporting-warehouse-data',
        props: true
    },
    {
        path: '/edytuj-magazyn-rejonowy',
        component: AddWarehouse,
        meta: { requiresAuth: true },
        name: 'edit-warehouse-data',
        props: true
    },
    {
        path: '/edytuj-magazyn-wspierajacy',
        component: AddWarehouse,
        meta: { requiresAuth: true },
        name: 'edit-supporting-warehouse-data',
        props: true
    }
];
